<div style="border: 1px solid lightgray;padding: 20px;border-radius: 17px;">
    <div class="row">
        <div class="col"></div>
        <div class="col-1"></div>
        <div class="col text-right">
            <button mat-raised-button color="warm" (click)="close()">close</button>
        </div>
    </div>
    <div class="row">
        <div class="col text-center" style="font-size: 16px;font-weight: bold;">
            Cheque Details
        </div>
    </div>
    <div class="row">
        <div class="col">
            <b> Cheque Number : </b> <label>{{cheque_data['cheque_number']}}</label>
        </div>
        <div class="col">
            <b> Date Of Issue : </b> <label>{{cheque_data['date_of_issue']}}</label>
        </div>
    </div>
    <hr>
    <div class="row">
            <div class="col text-center" style="font-size: 16px;font-weight: bold;">
                Booth Details
            </div>
        </div>
    <div class="row">
        <div class="col">
            <b> Agent Name : </b> <label>{{cheque_data['agent_name']}}</label>
        </div>
        <div class="col">
            <b> Booth code : </b> <label>{{cheque_data['business_code']}}</label>
        </div>
    </div>
    <hr>
    <div class="row">
            <div class="col text-center" style="font-size: 16px;font-weight: bold;">
                Bank Details
            </div>
        </div>
    <div class="row">
        <div class="col">
            <b> Account Holder Name : </b> <label>{{cheque_data['account_holder_name']}}</label>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <b> Account Number : </b> <label>{{cheque_data['account_number']}}</label>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <b> Bank Name : </b> <label>{{cheque_data['bank_name']}}</label>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <b> Branch Name : </b> <label>{{cheque_data['branch_name']}}</label>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <b> Ifsc Code : </b> <label>{{cheque_data['ifsc_code']}}</label>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <b> Micr Code : </b> <label>{{cheque_data['micr_code']}}</label>
        </div>
    </div>

    <div class="row">

        <div class="col-3" style="margin-left: 48px;">
            <mat-form-field appearance="outline" style="padding: 0px;">
                <mat-label>Approved on </mat-label>
                <input matInput [(ngModel)]="approved_on" class="inputs" type="date" placeholder="approved on">
            </mat-form-field>
        </div>

        <div class="col-3" style="margin-left: 100px;">
            <mat-form-field appearance="outline" style="padding: 0px;">
                <mat-label>Transaction id </mat-label>
                <input [(ngModel)]="transaction_id" matInput class="inputs" type=number placeholder="Transaction id" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
            </mat-form-field>
        </div>


    </div>
    <div class="row">
        <div class="col text-center">
            <button mat-raised-button color="primary" (click)="saveApproval()">Submit</button>
        </div>
    </div>
</div>